import { render, staticRenderFns } from "./importEmail.vue?vue&type=template&id=aea50f08&scoped=true"
import script from "./importEmail.vue?vue&type=script&lang=js"
export * from "./importEmail.vue?vue&type=script&lang=js"
import style0 from "./importEmail.vue?vue&type=style&index=0&id=aea50f08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea50f08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aea50f08')) {
      api.createRecord('aea50f08', component.options)
    } else {
      api.reload('aea50f08', component.options)
    }
    module.hot.accept("./importEmail.vue?vue&type=template&id=aea50f08&scoped=true", function () {
      api.rerender('aea50f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier/component/importEmail.vue"
export default component.exports